import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { TrashIcon } from "@common/trashIcon";
import { EditIcon } from "@common/editIcon";
import { EventIcon } from "@common/eventIcon";
import { useModal } from "@root/client/modal";
import { UseCases } from "@planzone/core";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidays({ calendarHolidays, isDefault }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  const edit = () =>
    pushView({
      data: calendarHolidays,
      key: UseCases.editCalendarHolidays,
    });

  const remove = () =>
    pushView({
      data: calendarHolidays,
      key: UseCases.removeCalendarHolidays,
    });

  const count = calendarHolidays.holidays?.length ?? 0;

  return (
    <div className={styles.row}>
      <div className={styles.tile}>
        <EventIcon className={styles.tileIcon} />
      </div>

      <div className={styles.main}>
        <p className={styles.name}>{calendarHolidays.name}</p>
        <p className={styles.meta}>
          {count === 0
            ? t("planzoneParametersPage.calendarHolidays.noHolidays")
            : t(
                count === 1
                  ? "planzoneParametersPage.calendarHolidays.holidaysCountSingular"
                  : "planzoneParametersPage.calendarHolidays.holidaysCountPlural",
                { count },
              )}
        </p>
      </div>

      {isDefault && (
        <span className={styles.defaultPill}>
          {t("planzoneParametersPage.calendarHolidays.defaultBadge")}
        </span>
      )}

      <div className={styles.actions}>
        <button
          type="button"
          className={classNames(styles.iconBtn, styles.edit)}
          onClick={edit}
          aria-label={t("planzoneParametersPage.calendarHolidays.editAction")}
        >
          <EditIcon className={styles.icon} />
        </button>
        <button
          type="button"
          className={classNames(styles.iconBtn, styles.remove)}
          onClick={remove}
          aria-label={t("planzoneParametersPage.calendarHolidays.removeAction")}
        >
          <TrashIcon className={styles.icon} />
        </button>
      </div>
    </div>
  );
}

export { CalendarHolidays };
